import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useLocale } from '../../i18n/locale-context.js';
export function TierDisclosureStep(props) {
    const { t } = useLocale();
    return (_jsxs("section", { "aria-labelledby": "tier-heading", children: [_jsx("h3", { id: "tier-heading", children: tierHeading(props.app.tier, t) }), renderTierBody(props.app, t), _jsxs("div", { role: "group", "aria-label": t('consent.tier.actions_aria_label'), children: [_jsx("button", { type: "button", onClick: props.onContinue, children: t('consent.tier.continue') }), _jsx("button", { type: "button", onClick: props.onCancel, children: t('consent.tier.cancel') })] })] }));
}
function tierHeading(tier, t) {
    switch (tier) {
        case 'tier-1':
            return t('consent.tier.heading.tier_1');
        case 'tier-2':
            return t('consent.tier.heading.tier_2');
        case 'tier-3':
            return t('consent.tier.heading.tier_3');
    }
}
function renderTierBody(app, t) {
    switch (app.tier) {
        case 'tier-1':
            return _jsx("p", { children: t('consent.tier.body.tier_1') });
        case 'tier-2':
            return _jsx("p", { children: t('consent.tier.body.tier_2') });
        case 'tier-3':
            return (_jsxs(_Fragment, { children: [_jsx("p", { children: t('consent.tier.body.tier_3_certified') }), app.useAuthorityCertificationRef !== undefined ? (_jsxs("p", { children: [t('consent.tier.body.tier_3_certification_ref_label'), ' ', _jsx("code", { children: app.useAuthorityCertificationRef })] })) : null, _jsx("p", { children: t('consent.tier.body.tier_3_audit_cadence') })] }));
    }
}
//# sourceMappingURL=tier-disclosure-step.js.map